export function convertTypeToDesignerType(type) {
    switch (type) {
        case "string":
            return "String";
        case "number":
            return "Number_Integer";
        case "boolean":
            return "Boolean";
        case "date":
            return "DateTime_Date";
        case "reference":
            return "String";
        case "longtext":
            return "Multiline Text";
        case "email":
            return "Email";
        case "picklist":
            return "Picklist String";
        case "user":
            return "User Identity";
        case "state":
            return "State Field";
        default:
            return "String";
    }
}